import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useBootstrapStatus, useRegister } from '../lib/queries.js';
import { ApiError } from '../lib/api.js';
import { GoogleSignInButton } from './GoogleSignInButton.js';

export function RegisterPage() {
  const bootstrap = useBootstrapStatus();
  const register = useRegister();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tos, setTos] = useState(false);
  const [aiOptIn, setAiOptIn] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const isFirst = bootstrap.data?.needs_first_user;

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (!tos) {
      setError('É necessário aceitar os Termos e Política.');
      return;
    }
    try {
      const res = await register.mutateAsync({
        email,
        password,
        name,
        consents: { tos: true, privacy: true, marketing: false, ai_processing: aiOptIn },
      });
      if (res.isSuperadmin) window.location.href = '/admin/bootstrap';
      else window.location.href = '/';
    } catch (err) {
      if (err instanceof ApiError && err.status === 409) setError('E-mail já em uso.');
      else if (err instanceof ApiError && err.status === 400) setError('Dados inválidos (senha deve ter 10+ caracteres).');
      else setError(err instanceof Error ? err.message : 'Erro');
    }
  }

  return (
    <main className="min-h-dvh flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-semibold text-cyan-400 mb-1">
          {isFirst ? 'Criar conta superadmin' : 'Criar conta'}
        </h1>
        <p className="text-zinc-500 text-sm mb-6">
          {isFirst
            ? 'Primeira conta do sistema. Você será promovido a superadmin automaticamente.'
            : 'E-mail e senha apenas — sem login social no MVP.'}
        </p>
        <form onSubmit={onSubmit} className="space-y-3">
          <input
            type="text"
            required
            placeholder="Seu nome"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2 focus:outline-none focus:border-cyan-500"
          />
          <input
            type="email"
            required
            autoComplete="email"
            placeholder="email@dominio.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2 focus:outline-none focus:border-cyan-500"
          />
          <input
            type="password"
            required
            minLength={10}
            autoComplete="new-password"
            placeholder="senha (mínimo 10 caracteres)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-md bg-zinc-900 border border-zinc-800 px-3 py-2 focus:outline-none focus:border-cyan-500"
          />
          <label className="flex items-start gap-2 text-sm text-zinc-400">
            <input
              type="checkbox"
              checked={tos}
              onChange={(e) => setTos(e.target.checked)}
              className="mt-1"
            />
            <span>
              Li e aceito os Termos de Uso e Política de Privacidade (LGPD).
            </span>
          </label>
          <label className="flex items-start gap-2 text-sm text-zinc-400">
            <input
              type="checkbox"
              checked={aiOptIn}
              onChange={(e) => setAiOptIn(e.target.checked)}
              className="mt-1"
            />
            <span>Permito processamento por IA (opcional — pode ativar depois).</span>
          </label>
          {error && <div className="text-rose-400 text-sm">{error}</div>}
          <button
            type="submit"
            disabled={register.isPending}
            className="w-full rounded-md bg-cyan-500 text-zinc-950 font-medium py-2 hover:bg-cyan-400 disabled:opacity-50"
          >
            {register.isPending ? 'criando…' : 'Criar conta'}
          </button>
        </form>

        <GoogleSignInButton />
      </div>
    </main>
  );
}
